import styled from "styled-components";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../utilities/constants";
import { useLanguage } from "../LangTranslation/LanguageContext";
import TableLoader from "../Loaders/TableLoader";
import { useState } from "react";
import { useSession } from "../../authentications/SessionContext";
import AttributeValueRow from "./AttributeValueRow";
// import ProductAttributeRow from "./ProductAttributeRow";

const Button = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: none;
  font-weight: 600;
  width: auto;
  min-width: 150px;
  height: 40px;
  margin-right: 110px;
  outline: none; /* Remove default button outline */
`;
function AttributeValuesTable({
  push,
  handleRemove,
  name,
  form,
  disabled,
  modelSpecific,
  color,
  fieldName,
  isCreateModalOpen,
  setIsCreateModalOpen,
  updatedData,
  setUpdatedData,
  modalType,
  isColor,
  touched,
  errors,
}) {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { values, setFieldValue } = form;
  const [attributesValueDetail, setProductAttributesDetail] = useState(false);
  const { attr_values } = values;

  return (
    <>
      <div className=" pb-4">
        {!attr_values.length > 0 && disabled && (
          <span
            className="alert alert-success d-flex align-items-center mb-0"
            role="alert"
            style={{
              height: 12 + "px",
              padding: "9px !important",
            }}
          >
            {t["Edit to add attribute values"]}
          </span>
        )}
        <div className="row overflow-auto">
          <table className="table position-relative">
            <thead>
              <tr className="heading_row">
                <th
                  style={{
                    textAlign: "center",
                    minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH,
                  }}
                >
                  {t["Value"]}
                </th>

                <th
                  style={{
                    textAlign: "center",
                    minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH,
                  }}
                >
                  {t["HEX Code"]}
                </th>
                {!disabled && <th style={{ minWidth: 20 }} />}
              </tr>
            </thead>

            <tbody style={{ minHeight: 120 }}>
              <TableLoader>
                {attr_values?.map((item, index) =>
                  item.isDeleted ? (
                    <></>
                  ) : (
                    <AttributeValueRow
                      key={index}
                      index={index}
                      item={item}
                      name={name}
                      handleRemove={handleRemove}
                      setFieldValue={setFieldValue}
                      disabled={disabled}
                      setProductAttributesDetail={setProductAttributesDetail}
                      modelSpecific={modelSpecific}
                      color={color}
                      fieldName={fieldName}
                      isCreateModalOpen={isCreateModalOpen}
                      setIsCreateModalOpen={setIsCreateModalOpen}
                      updatedData={updatedData}
                      setUpdatedData={setUpdatedData}
                      modalType={modalType}
                      isColor={isColor}
                      touched={touched}
                      errors={errors}
                      values={values}
                    />
                  )
                )}
              </TableLoader>
            </tbody>
          </table>
          {!disabled && (
            <Button
              onClick={() => {
                push({
                  id: `virtual_${parseInt(Math.random() * 1000)}`,
                  name: "",
                  hexCode: "",
                });
              }}
              role="button"
              type="button"
              style={{ color: isVTEX ? "#BAF76A" : "#ff5837" }}
            >
              + {t["Add a line"]}
            </Button>
          )}
          {touched["attr_values"] && errors["attr_values"] && (
            <span className="ps-2 error-message">
              {typeof errors["attr_values"] !== "object" &&
                errors["attr_values"]}
            </span>
          )}
        </div>
      </div>
    </>
  );
}

export default AttributeValuesTable;
